import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'date_of_birth',
    title: 'Date of birth',
    is_required: true,
    dateFormat: 'MM/DD/YYYY',
    question_type: 'date',
  },
  {
    id: 'drivers_license',
    title: 'Driver\'s license number or state ID',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'new_employee',
    title: 'Are you a new employee?',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'new_employee_yes',
        shortName: 'Yes',
      },
      {
        codeValue: 'new_employee_no',
        shortName: 'No',
      },
    ],
  },
];

export const dateOfHireInitialQuestion = [
  {
    id: 'date_of_hire',
    title: 'Date of hire',
    is_required: true,
    dateFormat: 'MM/DD/YYYY',
    question_type: 'date',
  },
];

export const initialExemptionQuestions = [
  {
    id: 'total_number_of_exemptions',
    title: 'Number of personal and dependent exemptions:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Additional amount you want deducted from each pay (if employer agrees):',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
